import axios from 'axios'

import config from '@/config/config'
import { getServerDateTime } from '@/utils/time'

export function initSelfcheck(soAuthToken, shopId, seatNo) {
  return axios.post(
    `${config.baseUrl}/app_order/selfcheck/initpage/v1/${shopId}/${seatNo}`,
    {
      requestedAt: getServerDateTime(new Date()),
      reserve: [],
    },
    { headers: { soAuthToken } }
  )
}

export function updateSelfcheckCount(soAuthToken, shopId, seatNo) {
  return axios.post(
    `${config.baseUrl}/app_order/selfcheck/timecount/reset/v1/${shopId}/${seatNo}`,
    {
      requestedAt: getServerDateTime(new Date()),
      reserve: [],
    },
    { headers: { soAuthToken } }
  )
}

export function createSelfcheckAmount(soAuthToken, shopId, seatNo) {
  return axios.post(
    `${config.baseUrl}/app_order/selfcheck/amountcalc/v1/${shopId}/${seatNo}`,
    {
      requestedAt: getServerDateTime(new Date()),
      reserve: [],
    },
    { headers: { soAuthToken } }
  )
}

export function confirmSelfcheck(soAuthToken, shopId, seatNo) {
  return axios.post(
    `${config.baseUrl}/app_order/selfcheck/confirmOk/v1/${shopId}/${seatNo}`,
    {
      requestedAt: getServerDateTime(new Date()),
      reserve: [],
    },
    { headers: { soAuthToken } }
  )
}

export function callStaffSelfcheck(soAuthToken, shopId, seatNo) {
  return axios.post(
    `${config.baseUrl}/app_order/selfcheck/call/v1/${shopId}/${seatNo}`,
    {
      requestedAt: getServerDateTime(new Date()),
      reserve: [],
    },
    { headers: { soAuthToken } }
  )
}

export function cancelSelfcheck(shopId, seatNo, callStaff) {
  return axios.post(`${config.baseUrl}/app_order/selfcheck/cancel/v1/${shopId}/${seatNo}`, {
    callStaff: callStaff ? 1 : 0,
    requestedAt: getServerDateTime(new Date()),
    reserve: [],
  })
}

export function fetchSeatAmount(soAuthToken, shopId, seatNo) {
  return axios.post(
    `${config.baseUrl}/app_order/seat/pay/v1/${shopId}/${seatNo}`,
    {
      requestedAt: getServerDateTime(new Date()),
      reserve: [],
    },
    { headers: { soAuthToken } }
  )
}
